import { Guid } from "guid-typescript";
import { IMessage } from "../../../IMessage";

//Generated code, do not modify

export class ArchiveActivityCommand implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<ArchiveActivityCommand>) {
        Object.assign(this, init);
    }

    getMethod = () => "PUT";

    getUrl = () => `/admin/activities/${this.id.toString()}/archive`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}